import { ApiFunction } from "../chatbot/towersChatbotApi";

export class ApiCallError extends Error {
    code;

    constructor(message, code) {
        super(message);
        this.code = code;
    }
}

export class TorresstreamApi {
    //static baseUrl = window.location.host === 'localhost:3000' ? "http://192.168.1.66:9001/torresstream/v3/call-function/" : 'https://torresowo.myftp.org:8098/torresstream/v3/call-function/';
    static baseUrl = 'https://torresowo.myftp.org:8098/torresstream/v3/call-function/';

    static getMovieTorrents(movieId, ignoreExisting) {
        return new ApiFunction('movieTorrents', this.baseUrl).call({ movieId, ignoreExisting });
    }

    static getEpisodeTorrents(serieId, seasonNumber, episodeNumber, ignoreExisting) {
        return new ApiFunction('serieTorrents', this.baseUrl).call({
            serieId,
            s: seasonNumber,
            e: episodeNumber,
            ignoreExisting
        });
    }

    static downloadTorrent(torrentId, tmdbId, season, episode) {
        return new ApiFunction('downloadTorrent', this.baseUrl).call({ torrentId, tmdbId, s: season, e: episode });
    }

    static getDownloadProgress(torrentId) {
        return new ApiFunction('getDownloadProgress', this.baseUrl).call({ torrentId });
    }

    static fetchOnlineSerieEpisode(serieId, seasonNumber, episodeNumber) {
        return new ApiFunction('fetchSerieEpisode', this.baseUrl).call({ serieId, s: seasonNumber, e: episodeNumber });
    }

    static fetchOnlineMovie(movieId) {
        return new ApiFunction('fetchMovie', this.baseUrl).call({ movieId });
    }

    static getItemTorrentsStatus(itemId, seasonNumber, episodeNumber) {
        return new ApiFunction('downloadStatus', this.baseUrl).call({
            tmdb_id: itemId,
            s: seasonNumber ?? -1,
            e: episodeNumber ?? -1
        });
    }

    static getAllDownloadsStatus() {
        return new ApiFunction('getAllDownloadsStatus', this.baseUrl).call({});
    }

    static getTorrentFileDetails(torrentId) {
        return new ApiFunction('torrentFileDetails', this.baseUrl).call({ torrentId });
    }

    static getFileUrlMetadata(fileUrl) {
        return new ApiFunction('remoteFileMetadata', this.baseUrl).call({ fileUrl });
    }

    static get(functionName) {
        return new ApiFunction(functionName, this.baseUrl);
    }

}

